export type SortDirection = 'asc' | 'desc';

export interface SortOption<T> {
  field: keyof T | ((item: T) => string | number | null | undefined);
  labelKey: string;
}

export interface SortConfig<T> {
  field: SortOption<T>['field'];
  direction: SortDirection;
}

export function sortItems<T>(items: T[], config: SortConfig<T>): T[] {
  const extract = typeof config.field === 'function'
    ? config.field
    : (item: T) => item[config.field as keyof T] as unknown as string | number | null;

  return [...items].sort((a, b) => {
    const va = extract(a) ?? '';
    const vb = extract(b) ?? '';
    const cmp = typeof va === 'number' && typeof vb === 'number'
      ? va - vb
      : String(va).localeCompare(String(vb));
    return config.direction === 'asc' ? cmp : -cmp;
  });
}
